import baseApi from './baseApi';
import {
  Environnement,
  GetApiKeyResponse,
  GetConfigClientQuery,
  GetConfigClientResponse,
} from './Schemas/GetConfigClient';
import {
  UpdateConfigAdhesionCommand,
  UpdateConfigConsentementCommand,
  UpdateConfigDemissionCommand,
  UpdateConfigGeneralCommand,
  UpdateConfigInvitationCommand,
  UpdateConfigPaiementCommand,
  UpdateInfoPersoMessagesCommand,
  UpdateProprietesMembreVisibiliteCommand,
  UpdateCorrespondanceCommand,
} from './Schemas/UpdateConfig';
import { UpdateConfigCarteMembreCommand } from './Schemas/WalletTemplate';


const configApi = baseApi.injectEndpoints({
  overrideExisting: true,
  endpoints: (builder) => ({
    getConfigClient: builder.query<GetConfigClientResponse, GetConfigClientQuery>({
      query: ({ id }) => `config/${id}`,
      providesTags: (_result, _error, arg) => [{ type: 'ConfigClient', id: arg.id }],
    }),
    getEnvironnement: builder.query<Environnement, void>({
      query: () => `config/environnement`,
      providesTags: [{ type: 'Environnement' }],
    }),

    updateConfigGeneral: builder.mutation<void, UpdateConfigGeneralCommand>({
      query: (body) => ({
        url: `config/general`,
        method: 'PUT',
        body,
      }),
      invalidatesTags: (_result, _error, arg) => [{ type: 'ConfigClient', id: arg.IdClient }],
    }),
    updateConfigCarteMembre: builder.mutation<void, UpdateConfigCarteMembreCommand>({
      query: (body) => ({
        url: `config/carteMembre`,
        method: 'PUT',
        body,
      }),
      invalidatesTags: (_result, _error, arg) => [{ type: 'ConfigClient', id: arg.idClient }],
    }),

    updateConfigPaiement: builder.mutation<void, UpdateConfigPaiementCommand>({
      query: (body) => ({
        url: `config/paiement`,
        method: 'PUT',
        body,
      }),
      invalidatesTags: (_result, _error, arg) => [{ type: 'ConfigClient', id: arg.IdClient }],
    }),

    updateConfigDemission: builder.mutation<void, UpdateConfigDemissionCommand>({
      query: (body) => ({
        url: `config/demission`,
        method: 'PUT',
        body,
      }),
      invalidatesTags: (_result, _error, arg) => [{ type: 'ConfigClient', id: arg.IdClient }],
    }),
    updateConfigInvitation: builder.mutation<void, UpdateConfigInvitationCommand>({
      query: (body) => ({
        url: `config/invitation`,
        method: 'PUT',
        body,
      }),
      invalidatesTags: (_result, _error, arg) => [{ type: 'ConfigClient', id: arg.IdClient }],
    }),
    updateConfigConsentement: builder.mutation<void, UpdateConfigConsentementCommand>({
      query: (body) => ({
        url: `config/consentement`,
        method: 'PUT',
        body,
      }),
      invalidatesTags: (_result, _error, arg) => [{ type: 'ConfigClient', id: arg.IdClient }],
    }),
    updateConfigAdhesion: builder.mutation<void, UpdateConfigAdhesionCommand>({
      query: (body) => ({
        url: `config/adhesion`,
        method: 'PUT',
        body,
      }),
      invalidatesTags: (_result, _error, arg) => [{ type: 'ConfigClient', id: arg.IdClient }],
    }),
    generateApiKey: builder.mutation<void, number>({
      query: (id) => ({
        url: `config/generateApiKey/${id}`,
        method: 'POST',
      }),
      invalidatesTags: (_result, _error, arg) => [{ type: 'ConfigClient', id: arg }],
    }),

    // New separated endpoints for OptionsInfoPerso
    updateInfoPersoMessages: builder.mutation<void, { clientId: number; command: UpdateInfoPersoMessagesCommand }>({
      query: ({ command }) => ({
        url: `config/infoPersoMessages`,
        method: 'PUT',
        body: command,
      }),
      invalidatesTags: (_result, _error, arg) => [{ type: 'ConfigClient', id: arg.clientId }],
    }),

    updateProprietesMembreVisibilite: builder.mutation<void, { clientId: number; command: UpdateProprietesMembreVisibiliteCommand }>({
      query: ({ command }) => ({
        url: `config/proprietesMembreVisibilite`,
        method: 'PUT',
        body: command,
      }),
      invalidatesTags: (_result, _error, arg) => [
        { type: 'ConfigClient', id: arg.clientId },
        { type: 'ProprieteMembrePerClient' },
      ],
    }),

    updateCorrespondance: builder.mutation<void, { clientId: number; command: UpdateCorrespondanceCommand }>({
      query: ({ command }) => ({
        url: `config/correspondance`,
        method: 'PUT',
        body: command,
      }),
      invalidatesTags: (_result, _error, arg) => [
        { type: 'ConfigClient', id: arg.clientId },
        { type: 'ProprieteMembrePerClient' },
        { type: 'ChampUtilisateur' },
      ],
    }),
    getApiKey: builder.query<GetApiKeyResponse, number>({
      query: (id) => `config/apiKey/${id}`,
    }),

  }),
});


export const {
  useGetConfigClientQuery,
  useGetApiKeyQuery,
  useUpdateConfigGeneralMutation,
  useUpdateConfigPaiementMutation,
  useUpdateConfigInvitationMutation,
  useUpdateConfigAdhesionMutation,
  useUpdateConfigDemissionMutation,
  useUpdateConfigConsentementMutation,
  useGenerateApiKeyMutation,
  useGetEnvironnementQuery,
  useUpdateConfigCarteMembreMutation,
  useUpdateInfoPersoMessagesMutation,
  useUpdateProprietesMembreVisibiliteMutation,
  useUpdateCorrespondanceMutation,
} = configApi;


export default configApi;
